<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class TransferBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const getSearchPageLabel = () => {
                const departureTitle =
                    transfersRuntimeStore.departurePoint.title ||
                    `${transfersRuntimeStore.departurePoint.name}, ${transfersRuntimeStore.departurePoint.countryName}`
                const arrivalTitle =
                    transfersRuntimeStore.arrivalPoint.title ||
                    `${transfersRuntimeStore.arrivalPoint.name}, ${transfersRuntimeStore.arrivalPoint.countryName}`

                return `${departureTitle} - ${arrivalTitle}`
            }
            const addSearchPageLink = items => {
                    items.push({
                        title: getSearchPageLabel(),
                        to: transfersRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                },
                addInfoPageLink = items => {
                    items.push({
                        title: this.product.info?.name,
                        to: transfersRuntimeStore.infoPageLink(this.product, this.searchRequest),
                        exact: true,
                    })
                }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'transfers':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'transfersComparison':
                    addSearchPageLink(items)
                    items.push({
                        title: this.$t('compare_transfers'),
                        disabled: true,
                    })
                    break
                case 'transfer':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    break
                case 'transferBooking':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'transferConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(TransferBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
